import React, { useState } from "react";
import {
  Typography, ListItemIcon, ListItemText, TextField, Box, Button, ListItem, List, IconButton
} from "@material-ui/core";
import { DeleteOutline, EditOutlined, InsertDriveFile } from '@material-ui/icons';
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from 'prop-types';

import icBlueAdd from '../assets/icons/icBlueAdd.png';
import FilePopover from '../file-management/file-popover';
import { baseAuthUrl } from '../authProvider';
import { useDataProvider, useTranslate } from 'react-admin';
import AcceptDelete from '../users/acceptdelete';
import { isImage } from '../utils';
import colors from '../CustomizedUIs/Colors';
import { usePopupState, bindToggle } from "material-ui-popup-state/hooks";
import Image from 'material-ui-image';
import CachedIcon from '@material-ui/icons/Cached';

var childItem = {
  overflow: "hidden", textOverflow: "ellipsis", maxWidth: "100px", fontFamily: "UniviaPro",
  fontWeight: 500,
  fontSize: 11,
  lineHeight: 1.2,
  fontStretch: "normal",
  fontStyle: "normal",
  letterSpacing: "normal",
}
var childItemName = {
  fontFamily: "UniviaPro",
  fontSize: 13,
  lineHeight: 1.25,
  letterSpacing: 0.13,
  color: '#4f5064',
  fontWeight: "normal",
  fontStretch: "normal",
  fontStyle: "normal",
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap'
}

const useStyles = makeStyles((theme) => ({
  root: {
    color: "#88898c",
    backgroundColor: 'white',
    display: 'flex',
    flexDirection: 'row',
    paddingLeft: 10,
  },
  largeIcon: {
    fontSize: "40px"
  },
  iconPopover: {
    minWidth: 30
  },
  iconContainer: {
    minWidth: 'unset',
    backgroundColor: '#e5f1f8',
    position: 'absolute',
    top: 26,
    right: 16
  },
  icon: {
    width: 16,
    height: 16
  },
  cellItem: {
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  childItem,
  childItemName,
  titlePopover: {
    fontFamily: "UniviaPro",
    fontSize: "13px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.25,
    letterSpacing: "0.13px",
  },
  input: {
    backgroundColor: '#f3f7fa',
    borderRadius: '2px',
    "&:hover": {
      backgroundColor: '#f3f7fa'
    }
  },
  underlineNotValue: {
    '&::before': {
      borderBottom: '1px solid' + colors.lightBlue['200']
    },
    '&:hover:not($disabled):before': {
      borderBottom: '1px solid' + colors.lightBlue['200']
    }
  },
  focuses: {
    backgroundColor: '#f3f7fa !important'
  },
  hiddenReload: {
    display: 'none'
  }
}));

let extension;
function AttachmentItem({ item, onDeleteOne, renameCategory, handleDownload, isDownload, hiddenReload }) {
  const dataProvider = useDataProvider();
  const translate = useTranslate();
  const classes = useStyles();
  const { name, type, size, fd, id } = item;
  const fileName = name.split('.');
  extension = fileName[fileName.length - 1]
  fileName.pop();
  const nameWithouExtension = fileName.join('.');
  const [textValue, setTextValue] = React.useState({
    name: nameWithouExtension,
  });
  const [validate, setValidate] = React.useState({
    name: {
      isError: true,
      message: ''
    },
  });
  const [showRename, setShowRename] = useState(false);
  const [showWarningDelete, setShowWarningDelete] = useState(false);
  const popupState = usePopupState({ variant: 'popper', popupId: 'acttachments' })

  const [state, setState] = useState({
    count: 0,
    show: true
  });

  const reload = () => {
    setState({ show: false })
    setTimeout(() => setState(state => ({ count: state.count + 1, show: true })), 500)
  };

  const renderCategoryIcon = () => () => {
    if (isImage(type)) {
      return <Box display='flex'>
        <Image
          src={state.show ? `${baseAuthUrl}/media/${fd}` : ''}
          // onClick={() => console.log('onClick')}
          aspectRatio={(16 / 9)}
          disableSpinner
          style={{ width: 40, height: 40, paddingTop: 0 }}
        />
        <IconButton
          variant="outlined"
          color='primary'
          size='small'
          aria-label="reload image"
          onClick={reload}
          style={{ marginLeft: 8, backgroundColor: '#ffffff', display: hiddenReload ? 'none' : 'block' }}
        >
          <CachedIcon />
        </IconButton>
      </Box>;
    } else {
      return <InsertDriveFile className={classes.largeIcon} />;
    }
  }

  const onKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      setShowRename(false);
      onRename(id, textValue.name + "." + extension);
    }
  }

  const textOnChange = prop => (e) => {
    e.stopPropagation();
    setTextValue({
      ...textValue, [prop]: e.target.value
    })
    validateFc(prop, e.target.value)
  }
  const validateFc = (prop, value) => {
    if (prop === 'name') {
      if (value.length === 0)

        setValidate({
          ...validate, [prop]: value.length === 0 ? {
            isError: true, message: 'required'
          } : {
              isError: false, message: ''
            }
        })
      else {
        const test = (/[*|\\:\/"<>?]/).test(value)
        setValidate({
          ...validate, [prop]: test === true ? {
            isError: true, message: "A file name can't contain any of the following characters: \\/:*?”<>| "
          } : {
              isError: false, message: ''
            }
        })
      }
    }
    else
      setValidate({
        ...validate, [prop]: value.length === 0 ? {
          isError: true, message: 'required'
        } : {
            isError: false, message: ''
          }
      })

  }

  const onDeleteItemClick = () => {
    popupState.close();
    setShowWarningDelete(true);
  }

  const onRename = (id, name) => {
    dataProvider('UPDATE', 'category/rename', {
      id,
      data: {
        name: name,
        parentId: item.parent
      }
    }).then(({ data }) => {
      renameCategory(data);
    }).catch(error => {
    });
  }

  return (
    <List style={{ paddingTop: 10, paddingBottom: 0 }}>
      <AcceptDelete handleopen={showWarningDelete} handleClose={() => setShowWarningDelete(false)}
        handledelete={() => onDeleteOne(id)} ContentText={translate('pos.categories.warningContentDelete')} Tittle={translate('pos.categories.warningTitleDelete')} />
      <ListItem className={classes.root} button={isDownload} onClick={() => handleDownload(item.id)}>
        <Box flex={1} className={classes.cellItem} style={{ maxWidth: 70 }}>
          {renderCategoryIcon()}
        </Box>
        <Box flex={7} className={classes.cellItem} style={{ paddingRight: 8, marginLeft: 8 }}>
          <Typography className={classes.childItemName}>{name}</Typography>
        </Box>
        <Box flex={1} className={classes.cellItem}>
          <Typography className={classes.childItem}>{`${Math.ceil(size / 1000000)}mb`}</Typography>
        </Box>
        {
          !isDownload ? <Box flex={1}></Box> : null
        }
      </ListItem>
      {
        !isDownload ?
          <Button style={{ padding: 7 }} className={classes.iconContainer} {...bindToggle(popupState)}>
            <img alt='' src={icBlueAdd} className={classes.icon} />
          </Button> : null
      }
      <FilePopover
        popupState={popupState}
      >
        <List component="nav" aria-label="main mailbox folders">
          {
            showRename ? (
              <ListItem>
                <TextField
                  label={translate(`pos.categories.enterName`)}
                  onKeyDown={(!validate.name.message !== "" && !validate.name.isError) && onKeyDown}
                  required
                  onBlur={() => {
                    validateFc('name', textValue.name)
                  }}
                  value={textValue.name}
                  error={validate.name.message !== "" && validate.name.isError}
                  helperText={validate.name.message}
                  fullWidth
                  onChange={textOnChange('name')}
                  variant="filled"
                  InputProps={{
                    className: classes.input,
                    classes: {
                      underline: textValue.name !== '' ? classes.underline : classes.underlineNotValue,
                      focused: classes.focuses
                    }
                  }}
                />
              </ListItem>
            ) : (
                <ListItem button onClick={(e) => setShowRename(true)}>
                  <ListItemIcon className={classes.iconPopover}>
                    <EditOutlined />
                  </ListItemIcon>
                  <Typography className={classes.titlePopover}>{translate('pos.categories.Rename')}</Typography>
                </ListItem>
              )
          }
          <ListItem button onClick={onDeleteItemClick}>
            <ListItemIcon className={classes.iconPopover}>
              <DeleteOutline />
            </ListItemIcon>
            <ListItemText primary={translate('pos.categories.Delete')} />
          </ListItem>
        </List>
      </FilePopover>
    </List >
  );
}

AttachmentItem.propTypes = {
  item: PropTypes.object.isRequired,
  onDeleteOne: PropTypes.func.isRequired,
  renameCategory: PropTypes.func.isRequired,
  handleDownload: PropTypes.func.isRequired,
  isDownload: PropTypes.bool.isRequired,
};

export default AttachmentItem;
